/**
 * External Dependencies
 */
import 'jquery';

document.addEventListener('DOMContentLoaded', () => {


  // START Tabs
  const tabsElems = document.querySelectorAll(".my-tabs .tabs li");
  const sectionsElems = document.querySelectorAll(".my-tabs .tab-content");
  
  // init tabs functions
  function _removeActiveTab () {
    tabsElems.forEach(tabElem => {
      tabElem.classList.remove("is-active");
    });
    sectionsElems.forEach(sectionElem => {
      sectionElem.classList.remove("is-active");
    });
  }
  function _addActiveTab (__tab) {
    __tab.classList.add("is-active");
    const href = __tab.querySelector("a").getAttribute("href");
    const matchingSection = document.querySelector(href);
    matchingSection.classList.add("is-active");
  }
  // init click on tabs
  tabsElems.forEach(tabElem => {
    tabElem.addEventListener("click", e => {
      e.preventDefault();
      _removeActiveTab();
      _addActiveTab(tabElem);
    });
  })
  // END Tabs


  // START Google Map
  const mapsElems = document.querySelectorAll('.acf-map');

  // init all google maps
  function _initGoogleMaps () {

    // if google map script is loaded, init all maps
    if (typeof google === 'object' && typeof google.maps === 'object') {

      const MAP_OPTIONS = {
        zoom: 16,
        fullscreenControl: false,
        mapTypeControl: false,
        streetViewControl: false,
        zoomControlOptions: {
          position: google.maps.ControlPosition.TOP_RIGHT,
        },
        mapId: '3ec63f434d51614b',
        center: { lat: 43.6713846, lng: -79.4307084 },
      };

      // init and reveal all maps
      mapsElems.forEach(mapElem => {
        var map = mapElem.querySelector('.google-map');
        map.style.visibility = 'visible';
        map.style.position = 'relative';
        _initSingleGM(mapElem);
      })

    } else {

      // hide all maps
      mapsElems.forEach(mapElem => {
        var map = mapElem.querySelector('.google-map');
        map.style.visibility = 'hidden';
        map.style.position = 'absolute';
      })

    }

  }
  _initGoogleMaps();
  
  function _initSingleGM (__mapElem) {
    
    // create map
    var map = new google.maps.Map(__mapElem.querySelector('.google-map'), MAP_OPTIONS);

    var bounds = new google.maps.LatLngBounds();

    // add markers
    var infoWindows = [];
    const markersElems = __mapElem.querySelectorAll('.markers .marker');
    markersElems.forEach(markerElem => {

      // set icon
      const icon = document.createElement('img');
      icon.src = markerElem.dataset.icon;
      
      var marker = new google.maps.marker.AdvancedMarkerElement({
        map,
        position: {
          lat: parseFloat( markerElem.dataset.lat ),
          lng: parseFloat( markerElem.dataset.lng )
        },
        content: icon
      });

      // set content
      const contentString = String(markerElem.innerHTML);

      const infoWindow = new google.maps.InfoWindow({
        content: contentString
      });
      infoWindows.push(infoWindow);

      // when the user clicks the marker, an info window opens
      marker.addListener("click", () => {
        // close all
        for (var i = 0; i < infoWindows.length; i++) {
          infoWindows[i].close();
        }
        // open
        infoWindow.open({
          anchor: marker,
          map,
        });
      });

      //extend the bounds to include each marker's position
      bounds.extend(marker.position);

    });

    // now fit the map to the newly inclusive bounds
    map.fitBounds(bounds);
    
    // hide markers list
    __mapElem.querySelector('.markers').style.display = 'none';

  }
  // END Google Map
  
  // START Cookie Consent
  const ckyButtonsElems = document.querySelectorAll('.cky-btn');
  ckyButtonsElems.forEach(ckyButtonElems => {
    ckyButtonElems.addEventListener("click", e => {
      _initGoogleMaps();
    });
  })
  document.querySelector('.cky-btn-close').addEventListener("click", e => {
    _initGoogleMaps();
  });

}, false);
